<template>
  <div>
    <div class="operations">
      <div style="flex:1"></div>
      <a-button @click="showForm = true">添加</a-button>
    </div>
    <GigaTable :gData="dataSource" :gColumns="columns" />
    <FilmCategoryForm :visible="showForm" :formData="formState" @formCancel="handleCancel" @formOk="handleOk" /> 
  </div>
</template>
<script>
import { getVehicleFilmCategory, editFilmCategory } from '../http/api'
import GigaTable from '../components/GigaTable.vue'
import FilmCategoryForm from '../components/form/FilmCategoryForm'
export default {
  components: {
    GigaTable,
    FilmCategoryForm
  },
  data() {
    return {
      showForm: false,
      formState: {},
      dataSource: [],
      columns: [{
        title: 'id',
        dataIndex: 'id',
        key: 'id',
        width: 80
      }, {
        title: '名称',
        dataIndex: 'name',
        key: 'name'
      }, {
        title: '排序',
        dataIndex: 'displayOrder',
        key: 'displayOrder'
      }, {
        title: '是否发布',
        dataIndex: 'isPublished',
        key: 'isPublished',
        customRender: val => <span v-html={val.value ? '已发布' : '未发布'} />
      }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        customRender: (val) => {
          return (
            <div>
              <a-dropdown trigger={['click']} overlay={(
                <a-menu>
                  <a-menu-item onClick={() => this.editFilmCategory(val.record)}>
                    <span>编辑</span>
                  </a-menu-item>
                  <a-menu-item onClick={() => this.editFilmCategory(val.record, 'publish')}>
                    <span v-html={val.record.isPublished ? '取消发布' : '发布'}></span>
                  </a-menu-item>
                  <a-menu-item onClick={() => this.editFilmCategory(val.record, 'del')}>
                    <span>删除</span>
                  </a-menu-item>
                </a-menu>
              )}>
                <a-button>操作</a-button>
              </a-dropdown>
            </div>
          )
        }
      }]
    }
  },
  created() {
    this.getVehicleFilmCategory()
  },
  methods: {
    setImg(e, type) {
      let img = e[0]
      let formState = this.formState
      formState[type] = img.url
      this.formState = JSON.parse(JSON.stringify(formState))
    },
    handleOk(formState) {
      editFilmCategory({variables: formState}).then(res => {
        console.log(res)
        this.handleCancel()
        this.getVehicleFilmCategory()
      }).catch(err => {
        console.log(err)
      })
    },
    editFilmCategory(record, type) {
      if (type == 'del') {
        this.handleOk({id: record.id, isDeleted: true})
      } else if (type == 'publish') {
        this.handleOk({id: record.id, isPublished: !record.isPublished})
      } else {
        this.formState = record
        this.showForm = true
      }
    },
    handleCancel() {
      this.showForm = false
      this.formState = {}
    },
    getVehicleFilmCategory() {
      getVehicleFilmCategory().then(res => {
        if (res.errors) {
          this.$message.error(res.errors[0].message)
          return
        }
        let dataSource = res.data.vehicleFilmCategory
        console.log(dataSource)
        this.dataSource = dataSource
      })
    }
  },
}
</script>
<style lang="scss" scoped>
  
</style>